import {Component, OnDestroy, OnInit} from '@angular/core';
import {of, ReplaySubject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {HttpErrorResponse} from '@angular/common/http';
import {OfwcaService} from '../../../shared/services/ofwca.service';
import {Ofwca} from '../../../shared/interface/ofwca';
import {takeUntil} from 'rxjs/operators';
import {Contract} from '../../../shared/interface/contract';
import {ListResponse} from '../../../shared/interface/response/list-response';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {ContractAddDialogComponent} from '../../contracts/contract-add-dialog/contract-add-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {Document} from '../../../shared/interface/document';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';
import {DocumentAddDialogComponent} from '../../documents/document-add-dialog/document-add-dialog.component';
import {
  ACTIVE_REGISTRATION_STATUSES,
  ARCHIVE_REGISTRATION_STATUSES, CONTRACT_TYPE_TERMINAL,
  DICT_TYPE_TEMPLATE_TYPE,
  DictService,
  FILE_TYPE_AGREEMENT_ON_WALLET_REASSIGN,
  FILE_TYPE_ALLIANZ_CERT,
  FILE_TYPE_ALLIANZ_CERT_DOCUMENTS,
  FILE_TYPE_ALLIANZ_CERT_FRAUDS,
  FILE_TYPE_ALLIANZ_CERT_MY_CAR, FILE_TYPE_AML_CERTIFICATE,
  FILE_TYPE_ANNEX_OFWCA_APPLICATION,
  FILE_TYPE_ANOTHER_MULTI,
  FILE_TYPE_AUTHORIZATION,
  FILE_TYPE_CERT_100P,
  FILE_TYPE_CERT_40P,
  FILE_TYPE_CONTRACT_WITH_EMPLOYEE,
  FILE_TYPE_DIPLOMA, FILE_TYPE_IDD_TRAINING_STATEMENT,
  FILE_TYPE_INFORMATION_CLAUSE_FOR_OFWCA, FILE_TYPE_INITIAL_TRAINING,
  FILE_TYPE_KRK,
  FILE_TYPE_OFWCA_APPLICATION,
  FILE_TYPE_PERSONAL_QUESTIONNAIRE_PZU, RECEIVABLES_IMPORT_ROW_STATUS,
  TEMPLATE_TYPE_CONTRACT_WITH_EMPLOYEE,
  TEMPLATE_TYPE_INFORMATION_ABOUT_RODO
} from '../../../shared/services/dict.service';
import {
  RegistrationAddDialogComponent
} from '../../registrations/registration-add-dialog/registration-add-dialog.component';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {
  RegistrationsAddMultipleDialogComponent
} from "../../registrations/registrations-add-multiple-dialog/registrations-add-multiple-dialog.component";
import {Uuid} from "../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../shared/components/job-result-dialog/job-result-dialog.component";
import {FilterService} from "../../../shared/services/filter.service";
import {TemplateService} from "../../../shared/services/template.service";
import {NoteAddDialogComponent} from "../../note/note-add-dialog/note-add-dialog.component";
import {Note} from "../../../shared/interface/note";
import {
  AffiliateCodeAddDialogComponent
} from "../../affiliate-code/affiliate-code-add-dialog/affiliate-code-add-dialog.component";
import {AffiliateCode} from "../../../shared/interface/affiliateCode";
import {IddTraining} from "../../../shared/interface/idd-training";
import {IddTrainingService} from "../../../shared/services/idd-training.service";
import {AffiliateCodeService} from "../../../shared/services/affiliate-code.service";
import {HiperioParameterConfig, HiperioRegistrationConfig} from "../../../shared/interface/hiperio-registration-config";
import {
  ChangeParameterDialogComponent
} from "../../agents-profile-hiperio/change-parameter-dialog/change-parameter-dialog.component";
import {AgentsProfileHiperioService} from "../../../shared/services/agents-profile-hiperio.service";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import {
  ConcludeChangeRegistrationDialogComponent,
  ConcludeChangeRegistrationDialogData
} from "../../agents-profile-hiperio/conclude-change-registration-dialog/conclude-change-registration-dialog.component";

@Component({
  selector: 'app-ofwca-details',
  templateUrl: './ofwca-details.component.html',
  styleUrls: ['./ofwca-details.component.scss']
})
export class OfwcaDetailsComponent implements OnInit, OnDestroy {
  readonly ACTIVE_DOCUMENTS = 'active_documents';
  readonly ARCHIVE_DOCUMENTS = 'archive_documents';
  readonly ACTIVE_VIEW = 'active_view';
  readonly ARCHIVE_VIEW = 'archive_view';
  readonly ACTIVE_STATUSES = ACTIVE_REGISTRATION_STATUSES;
  readonly ARCHIVE_STATUSES = ARCHIVE_REGISTRATION_STATUSES;

  readonly DOCUMENRS_TYPES = [FILE_TYPE_DIPLOMA,
    FILE_TYPE_INFORMATION_CLAUSE_FOR_OFWCA, FILE_TYPE_PERSONAL_QUESTIONNAIRE_PZU,
    FILE_TYPE_AGREEMENT_ON_WALLET_REASSIGN, FILE_TYPE_CERT_100P,
    FILE_TYPE_CERT_40P, FILE_TYPE_ANOTHER_MULTI, FILE_TYPE_KRK, FILE_TYPE_AUTHORIZATION,
    FILE_TYPE_CONTRACT_WITH_EMPLOYEE, FILE_TYPE_IDD_TRAINING_STATEMENT, FILE_TYPE_INITIAL_TRAINING,
    FILE_TYPE_ALLIANZ_CERT, FILE_TYPE_ALLIANZ_CERT_FRAUDS, FILE_TYPE_ALLIANZ_CERT_DOCUMENTS,
    FILE_TYPE_ALLIANZ_CERT_MY_CAR, FILE_TYPE_INFORMATION_CLAUSE_FOR_OFWCA, FILE_TYPE_OFWCA_APPLICATION,
    FILE_TYPE_AML_CERTIFICATE
  ];

  ofwcaId?: string = null;
  initialFilters: any;
  ofwca: ReplaySubject<Ofwca> = new ReplaySubject(1);
  notes: ReplaySubject<Note[]> = new ReplaySubject<Note[]>(1);
  ofwcaObject?: Ofwca = null;
  modify = false;
  contracts: ReplaySubject<Contract[]> = new ReplaySubject<Contract[]>(1);
  contractsRegistration: ReplaySubject<Contract[]> = new ReplaySubject<Contract[]>(1);
  hasContracts = false;
  isLoadingContracts = true;
  documents: ReplaySubject<Document[]> = new ReplaySubject<Document[]>(1);
  registrationsChanged: ReplaySubject<any> = new ReplaySubject<any>(1);
  userPermissions: ReplaySubject<UserPermissions>;
  registrationsViewControl: FormControl;
  documentsViewControl: FormControl;
  generatingDocument = false;
  typeControl: FormControl;
  affiliateCode: ReplaySubject<AffiliateCode[]> = new ReplaySubject<AffiliateCode[]>(1);
  iddTrainingObject?: IddTraining;
  hiperioRegistrationConfig: ReplaySubject<HiperioRegistrationConfig[]> = new ReplaySubject<HiperioRegistrationConfig[]>(1);
  parameter?: HiperioParameterConfig;
  userPermissionss: UserPermissions;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ofwcaService: OfwcaService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private filterService: FilterService,
    private auth: AuthService,
    private fb: FormBuilder,
    private dictService: DictService,
    private templateService: TemplateService,
    private iddTrainingService: IddTrainingService,
    private affiliateCodeService: AffiliateCodeService,
    private agentsProfileHiperioService: AgentsProfileHiperioService,
  ) {
    this.auth.getUserPermissions()
      .subscribe((userPermissions: UserPermissions) => {
        this.userPermissionss = userPermissions;
      });
    this.userPermissions = auth.getUserPermissions();
    this.registrationsViewControl = fb.control(this.ACTIVE_VIEW);
    this.documentsViewControl = fb.control(this.ACTIVE_DOCUMENTS);
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.ofwcaId = params.id;
        this.loadOfwca();
      });
    this.typeControl = this.fb.control('');

    this.typeControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((dictId: number) => {
        if (!dictId) {
          this.loadDocuments(this.documentsViewControl.value);
        }
      });

    this.documentsViewControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((view: string) => {
        if (view) {
          if (this.typeControl != null) {
            this.loadDocuments(view, this.typeControl.value);
          } else {
          this.loadDocuments(view);
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onTabChange(e: MatTabChangeEvent): void {
    if (e.tab.textLabel === 'Umowy') {
      this.loadContracts();
    }

    if (e.tab.textLabel === 'Umowy z pracownikiem') {
      this.loadContractsRegistration();
    }

    if (e.tab.textLabel === 'Dokumenty') {
      this.loadDocuments(this.documentsViewControl.value);
    }
    if (e.tab.textLabel === 'Notatki') {
      this.loadNotes();
    }
    if (e.tab.textLabel === 'Linki afiliacyjne') {
      this.loadAffiliateCode();
    }
    if (e.tab.textLabel === 'Rejestracje') {
      this.loadIddTraining();
    }
    if (e.tab.textLabel === 'Hiperio') {
      this.loadHiperioRegistration();
    }
  }

  loadContracts(): void {
    this.ofwcaService.getOfwcaContracts(this.ofwcaId)
      .subscribe((contracts: ListResponse<Contract>) => {
        this.contracts.next(contracts.items);
      });
  }

  loadContractsRegistration(): void {
    this.ofwcaService.getOfwcaContractsRegistrationsPartnership(this.ofwcaId)
      .subscribe((contracts: ListResponse<Contract>) => {
        this.hasContracts = contracts.items.length > 0;
        this.contractsRegistration.next(contracts.items);
        this.isLoadingContracts = false;
      });
  }

  loadDocuments(documentView?: string, id?: number): void {
    this.ofwcaService.getOfwcaDocuments(this.ofwcaId, documentView, id)
      .subscribe((documents: ListResponse<Document>) => {
        this.documents.next(documents.items);
      });
  }

  addContract(): void {
    const dialogRef = this.dialog.open(ContractAddDialogComponent, {
      width: '55%',
      data: {ofwca: this.ofwcaObject},
      height: '570px',
      maxHeight: '90%',
      panelClass: 'full-height-dialog',
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadContracts();
    });
  }

  loadOfwca(): void {
    this.ofwcaService.get(this.ofwcaId).subscribe((ofwca: Ofwca) => {
      this.ofwca.next(ofwca);
      this.ofwcaObject = ofwca;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych OFWCA', error.status.toString(), {
        duration: 2000
      });

      this.router.navigate(['/ofwca']);
    });
  }

  loadNotes(): void {
    this.ofwcaService.getOfwcaNotes(this.ofwcaId)
      .subscribe((note: ListResponse<Note>) => {
        this.notes.next(note.items);
      });
  }

  addDocument(): void {
    const dialogRef = this.dialog.open(DocumentAddDialogComponent, {
      width: '55%',
      data: {
        ofwcaObject: this.ofwcaObject,
        types: [
          FILE_TYPE_DIPLOMA,
          FILE_TYPE_CERT_100P,
          FILE_TYPE_INFORMATION_CLAUSE_FOR_OFWCA,
          FILE_TYPE_PERSONAL_QUESTIONNAIRE_PZU,
          FILE_TYPE_AGREEMENT_ON_WALLET_REASSIGN,
          FILE_TYPE_CONTRACT_WITH_EMPLOYEE
        ],
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.documentsViewControl.setValue(this.ACTIVE_DOCUMENTS);
      this.loadDocuments(this.documentsViewControl.value);
    });
  }

  addContractWithEmployee(): void {
    const dialogRef = this.dialog.open(DocumentAddDialogComponent, {
      width: '55%',
      data: {
        ofwcaObject: this.ofwcaObject,
        types: [
          FILE_TYPE_CONTRACT_WITH_EMPLOYEE
        ],
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadDocuments();
    });
  }

  generateContractWithEmployee(onlyNew: boolean): void {
    this.generatingDocument = true;
    this.dictService.getId(TEMPLATE_TYPE_CONTRACT_WITH_EMPLOYEE, DICT_TYPE_TEMPLATE_TYPE)
      .subscribe((dictId: number) => {
        this.templateService.generate({
          type: dictId,
          ofwca: this.ofwcaObject.uuid,
          onlyNew
        }).subscribe((response: Uuid) => {
          const dialogRef = this.dialog.open(JobResultDialogComponent, {
            disableClose: true,
            width: '500px',
            data: {jobId: response.uuid, showProgress: false},
          });

          dialogRef.afterClosed().subscribe(() => {
            this.generatingDocument = false;
          });
        }, (error: HttpErrorResponse) => {
          this.generatingDocument = false;
          if (error.status === 404) {
            this.snack.open('Brak szablonów dla tego typu dokumentu', '', {duration: 2000});
            return;
          }

          this.snack.open('Przy generowaniu dokumentów wystąpił błąd', error.status.toString(), {duration: 2000});
        });
      });
  }

  downloadDocument(onlyAuthorizations: boolean , onlyPowersOfAttorney: boolean): void {
    this.generatingDocument = true;
    this.dictService.getId(TEMPLATE_TYPE_INFORMATION_ABOUT_RODO, DICT_TYPE_TEMPLATE_TYPE)
      .subscribe((dictId: number) => {
        this.templateService.generate({
          type: dictId,
          ofwca: this.ofwcaObject.uuid,
          onlyAuthorizations,
          onlyPowersOfAttorney,
          documentsView: this.documentsViewControl.value
        }).subscribe((response: Uuid) => {
          const dialogRef = this.dialog.open(JobResultDialogComponent, {
            disableClose: true,
            width: '500px',
            data: {jobId: response.uuid, showProgress: false},
          });

          dialogRef.afterClosed().subscribe(() => {
            this.generatingDocument = false;
          });
        }, (error: HttpErrorResponse) => {
          this.generatingDocument = false;
          if (error.status === 404) {
            this.snack.open('Brak szablonów dla tego typu dokumentu', '', {duration: 2000});
            return;
          }

          this.snack.open('Przy generowaniu dokumentów wystąpił błąd', error.status.toString(), {duration: 2000});
        });
      });

  }
  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      ofwca: 'string',
    }, filters);
  }
  buildFilters(): any {
    const filters = {...this.initialFilters};

      filters.ofwca = this.ofwcaObject.uuid;

    return filters;
  }
  downloadReport(): void {
    this.ofwcaService.downloadRegistrationReport(this.buildFilters())
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });

  }

  addNote(): void {
    const dialogRef = this.dialog.open(NoteAddDialogComponent, {
      width: '90%',
      data: {ofwca: this.ofwcaObject},
      height: '90%',
      maxHeight: '90%',
      panelClass: 'full-height-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadNotes();
    });
  }

  downloadMeetingReport(): void {
    this.ofwcaService.downloadMeetingReport(this.buildFilters(),  this.ofwcaObject.uuid )
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });

  }

  addRegistration(): void {
    const dialogRef = this.dialog.open(RegistrationAddDialogComponent, {
      width: '90vw',
      maxHeight: '90vh',
      data: {
        ofwcaObject: this.ofwcaObject,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.registrationsChanged.next(true);
    });
  }
  addMultipleRegistration(): void {
    const dialogRef = this.dialog.open(RegistrationsAddMultipleDialogComponent, {
      width: '90vw',
      maxHeight: '90vh',
      data: {
        ofwcaObject: this.ofwcaObject,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.registrationsChanged.next(true);
    });
  }
  filtrReset(): void {
    this.typeControl.reset();
    this.loadDocuments();
  }

  addAffiliateCod(): void {
    const dialogRef = this.dialog.open(AffiliateCodeAddDialogComponent, {
      width: '55%',
      data: {
        ofwcaObject: this.ofwcaObject,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadAffiliateCode();
    });
  }

  downloadAffiliateLinkRaport(): void {
    this.ofwcaService.downloadReportAffiliateLink(this.buildFilters(),  this.ofwcaObject.uuid )
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  loadAffiliateCode(): void {
    this.ofwcaService.getAffiliateCode(this.ofwcaId)
      .subscribe((affiliateCode: ListResponse<AffiliateCode>) => {
        this.affiliateCode.next(affiliateCode.items);
      });
  }

  loadIddTraining(): void {
    if (!this.ofwcaId) {
      return;
    }
    const iddTrainingsSubject = new ReplaySubject<ListResponse<IddTraining>>(1);

    iddTrainingsSubject.subscribe({
      next: (response) => {
        if (response.items && response.items.length > 0) {
          const newest = response.items.reduce((prev, current) =>
            prev.year > current.year ? prev : current
          );
          this.iddTrainingObject = newest;
        } else {
          this.iddTrainingObject = null;
        }

      },
      error: () => {
        this.snack.open('Nie udało się pobrać szkolenia IDD', '', { duration: 2000 });
      }
    });
    this.iddTrainingService.loadNotCountedList(0, 1000, { ofwca: this.ofwcaId }, iddTrainingsSubject);
  }


  loadHiperioRegistration(): void {
    if (this.ofwcaObject?.hiperioAgencyUnitsUuid) {
      this.ofwcaService.getHiperioConfig(this.ofwcaId)
        .subscribe((hiperioRegistrationConfig: ListResponse<HiperioRegistrationConfig>) => {
          this.hiperioRegistrationConfig.next(hiperioRegistrationConfig.items);
          if (this.userPermissionss?.hiperio?.write) {
            this.agentsProfileHiperioService.getParameter(this.ofwcaObject.hiperioAgencyUnitsUuid,
            ).subscribe((parameter: HiperioParameterConfig) => {
              this.parameter = parameter;
            }, (error: HttpErrorResponse) => {
              this.snack.open('Nie udało się pobrać danych', error.status.toString(), {
                duration: 2000
              });
            });
          }

        });
    }
  }

  changeParameter(): void {
    const dialogRef = this.dialog.open(ChangeParameterDialogComponent, {
      width: '80vw',
      maxHeight: '90vh',
      data: {
        parameter: this.parameter
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadHiperioRegistration();
    });
  }

  concludeParameter(): void {
    const dialogRef = this.dialog.open(ConcludeChangeRegistrationDialogComponent, {
      width: '80vw',
      maxHeight: '90vh',
      data: {
        ofwca: this.ofwcaObject,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadHiperioRegistration();
    });
  }

  sendTestAccessForm(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz zawnioskować o dostępy testowe?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
            this.agentsProfileHiperioService.sendTestAccessForm(this.ofwcaObject.uuid)
              .subscribe(() => {
                this.snack.open('Pomyślnie zawnioskowano o dostępy testowe', '', {duration: 2000});
              } , (error: HttpErrorResponse) => {
                this.snack.open('Przy dodawaniu zgłoszenia wystąpił błąd', error.status.toString(), {duration: 2000});
                if (error.status === 400) {
                  this.snack.open(error.error.error.text, '400', {duration: 4000});
                }
              });
      }
    });
  }

}
